import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

//type Guid = any;

export class v_InventoryCostHistoryBus extends BaseBus
{
    constructor(busObj: v_InventoryCostHistoryBus = null) {
        super(busObj);
        if (busObj) {
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
        }
    }
    CID() {
        return this.inventoryCostHistoryId;
    }
    inventoryCostHistoryId: any;
    inventoryId: any;
    number: string;
    inventoryDesc: string;
    period: string;
    year: number;
    month: number;
    quantity: number;
    avgCost: number;
    maxCost: number;
    minCost: number;
    pctDiff: number;
    pctDiffFlag: boolean;
    isAcknowledged: boolean;
    pctDiffException: boolean;
    inventoryCostAdjustmentId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
}
